var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavLocationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.33331C10.0667 5.33331 8 6.79998 8 9.33331C8 11.6 11.2 14.8666 11.5333 15.2C11.6667 15.3333 11.8667 15.4 12 15.4C12.1333 15.4 12.3333 15.3333 12.4667 15.2C12.8 14.8666 16 11.6 16 9.33331C16 6.79998 13.9333 5.33331 12 5.33331ZM12 10.6666C11.2667 10.6666 10.6667 10.0666 10.6667 9.33331C10.6667 8.59998 11.2667 7.99998 12 7.99998C12.7333 7.99998 13.3333 8.59998 13.3333 9.33331C13.3333 10.0666 12.7333 10.6666 12 10.6666Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.26667C4.4 7.73333 5 8 5.66667 8C6.13333 8 6.53333 7.86667 6.93333 7.6C7.66667 5.33333 9.86667 4 12 4C12.8 4 13.6 4.2 14.3333 4.53333L11.9333 0.333333C11.8 0.133333 11.6 0 11.3333 0H3.33333C3.06667 0 2.86667 0.133333 2.73333 0.333333L0.0666667 5C0 5.13333 0 5.2 0 5.33333C0 6.93333 0.933333 8 2.33333 8C3 8 3.6 7.73333 4 7.26667Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 9.33335C6.66667 9.26668 6.66667 9.26668 6.66667 9.20002C6.33333 9.26668 6 9.33335 5.66667 9.33335C5.06667 9.33335 4.53333 9.20002 4 8.93335C3.46667 9.20002 2.93333 9.33335 2.33333 9.33335C2.2 9.33335 2.13333 9.33335 2 9.33335V14C2 14.4 2.26667 14.6667 2.66667 14.6667H9.26667C8.06667 13.2667 6.66667 11.1333 6.66667 9.33335Z",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLocationIcon);
export default __webpack_public_path__ + "static/media/nav-location-icon.045721c0.svg";
export { ForwardRef as ReactComponent };